import {
  LEGALITYDOCUMENT_LOADING,
  GET_LEGALITYDOCUMENT,
  GET_LEGALITYDOCUMENT_SUCCESS,
  GET_LEGALITYDOCUMENT_FAIL,
  ADD_LEGALITYDOCUMENT_SUCCESS,
  ADD_LEGALITYDOCUMENT_FAIL,
  DELETE_LEGALITYDOCUMENT_SUCCESS,
  DELETE_LEGALITYDOCUMENT_FAIL,
  UPDATE_LEGALITYDOCUMENT_SUCCESS,
  UPDATE_LEGALITYDOCUMENT_FAIL,
  LEGALITYDOCUMENT_RESET
} from "./actionType";

const INIT_STATE = {
  legalityDocuments: [],
  error: {},
};

const LegalityDocument = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LEGALITYDOCUMENT_SUCCESS:
      switch (action.payload.actionType) {
        case GET_LEGALITYDOCUMENT:
          return {
            ...state,
            legalityDocuments: action.payload.data,
            isLegalityDocumentCreated: false,
            isLegalityDocumentSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_LEGALITYDOCUMENT_FAIL:
      switch (action.payload.actionType) {
        case GET_LEGALITYDOCUMENT_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isLegalityDocumentCreated: false,
            isLegalityDocumentSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_LEGALITYDOCUMENT: {
      return {
        ...state,
        isLegalityDocumentCreated: false,
        loading: true,
      };
    }

    case LEGALITYDOCUMENT_LOADING: {
      return {
        ...state,
        isLegalityDocumentCreated: false,
        loading: true,
      };
    }

    case ADD_LEGALITYDOCUMENT_SUCCESS:
      return {
        ...state,
        isLegalityDocumentCreated: true,
        loading: false,
        legalityDocuments: [action.payload.data, ...state.legalityDocuments],
      };

    case ADD_LEGALITYDOCUMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_LEGALITYDOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        legalityDocuments: state.legalityDocuments.filter(
          civilLegalityDocument => civilLegalityDocument.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_LEGALITYDOCUMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_LEGALITYDOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        legalityDocuments: state.legalityDocuments.map(civilLegalityDocument =>
          civilLegalityDocument.id.toString() === action.payload.data.id.toString() ? { ...civilLegalityDocument, ...action.payload.data } : civilLegalityDocument
        ),
      };

    case UPDATE_LEGALITYDOCUMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case LEGALITYDOCUMENT_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default LegalityDocument;